import { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { Label, TextInput, Button, Popover } from "flowbite-react";
import { SportsMapInv } from "./pages/SportMap";
import { FaSearch } from "react-icons/fa";

export const SearchBar = () => {
  const [searchResults, setSearchResults] = useState();

  const navigate = useNavigate();
  const [popen, setPopen] = useState(false);
  const handleSearch = (e) => {
    e.preventDefault();
    let query = e.target.search.value.trim();
    fetch("/api/search", {
      method: "POST",
      body: JSON.stringify({ query: query }),
    })
      .then((resp) => resp.json())
      .then((resp) => {
        setPopen(false);
        navigate("/search/results", { state: resp });
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <div className="hidden md:flex">
        <div className="grow my-auto py-auto h-fit">
          <form onSubmit={handleSearch} action="">
            <div className="grow flex-row w-full">
              <TextInput
                required
                id="search"
                type="search"
                placeholder="Search for a team, player, or conference"
              />
            </div>
          </form>
        </div>
      </div>
      <div className="md:hidden flex grow h-fit mx-auto">
        <Popover
          open={popen}
          onOpenChange={setPopen}
          content={
            <div className="flex justify-around px-auto mx-auto">
              <form onSubmit={handleSearch} action="">
                <div className="flex flex-row w-full">
                  <TextInput
                    required
                    id="search"
                    type="search"
                    placeholder="Search for a team, player, or conference"
                  />
                </div>
              </form>
            </div>
          }
        >
          <Button pill color="gray">
            <FaSearch />
          </Button>
        </Popover>
      </div>
    </>
  );
};

export const SearchResults = () => {
  const loc = useLocation();
  const searchResults = loc.state;
  document.title = "NILO - Search Results";
  return (
    <div>
      {searchResults !== undefined ? (
        <>
          {" "}
          {/* BEGINNING OF SEARCH RESULTS */}
          <div className="w-full">
            {/* Teams */}
            <div className="w-full flex flex-col justify-around">
              <div className="w-full flex">
                <p className="font-semibold">Teams</p>
              </div>
              <hr className="my-2" />
              {searchResults && searchResults.teams.length > 0 ? (
                <div className="sm:columns-3 md:columns-4 sm:gap-6">
                  {searchResults.teams.map((team) => {
                    return (
                      <div
                        key={team.nilo_id}
                        className="flex break-inside-avoid-column px-8 py-4"
                      >
                        <Link to={`/Team/${team.nilo_id}`}>
                          <div className="font-extrabold">{team.name}</div>
                          <div className="font-medium">
                            {SportsMapInv[team.sport]}
                          </div>
                        </Link>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="sm:w-full md:w-[600px] lg:w-[960px] justify-around italic">
                  No Results
                </div>
              )}
            </div>
            {/* End Teams */}
            {/* Players */}
            <div className="w-full flex flex-col justify-around">
              <div className="w-full flex">
                <p className="font-semibold">Players</p>
              </div>
              <hr />
              {searchResults && searchResults.players.length > 0 ? (
                <>
                  <div className="sm:columns-3 md:columns-4 sm:gap-6">
                    {searchResults.players.map((player) => {
                      return (
                        <div
                          key={player.nilo_id}
                          className="flex break-inside-avoid-column px-8 py-4"
                        >
                          <Link to={`/Player/${player.nilo_id}`}>
                            <div className="font-extrabold">{player.name}</div>
                            <div className="font-light">{player.team}</div>
                            <div className="font-extralight">
                              {SportsMapInv[player.sport]}
                            </div>
                          </Link>
                        </div>
                      );
                    })}
                  </div>
                </>
              ) : (
                <div className="sm:w-full md:w-[600px] lg:w-[960px] justify-around italic">
                  No Results
                </div>
              )}
            </div>
            {/* End Players */}
          </div>
          {/* END OF SEARCH RESULTS */}
        </>
      ) : (
        <></>
      )}
    </div>
  );
};
